<div [class.actor-edit-wrapper]="true" [class.loadingResults]="isLoadingSearchResults || isLoadingMotivationSuggestion">
  <app-base-modal dialogTitle="Threat Actor Change" (closeEvent)="onCancel()">
    <mat-radio-group
      [(ngModel)]="editMode"
      class="search-create-radio-group"
      (ngModelChange)="onEditModeSelected($event)"
    >
      <mat-radio-button value="searchForActor">Search for actor</mat-radio-button>
      <mat-radio-button value="createAnActor">Create an actor</mat-radio-button>
    </mat-radio-group>

    <!-- Search for Actor -->
    <div [hidden]="editMode !== 'searchForActor'">
      <!-- Search field and button -->
      <form [formGroup]="searchForActorForm" class="search-for-actor-form">
        <mat-form-field class="search-for-actor-form-field" appearance="outline" floatLabel="always">
          <mat-label>Search for actor</mat-label>
          <input type="text" placeholder="Search for an actor" matInput [formControl]="searchForActorFormControl" />
        </mat-form-field>

        <button
          class="button-primary"
          type="submit"
          mat-flat-button
          aria-label="Search actor"
          [disabled]="this.searchForActorForm.invalid"
          (click)="onSearchAsync()"
        >
          Search
        </button>
      </form>

      <!-- Actors table -->
      <div>
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 custom-table">
          <!-- Radio Button -->
          <ng-container matColumnDef="selectRadio">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row">
              <mat-radio-button
                [value]="row"
                [attr.aria-label]="'Select ' + row.name"
                [checked]="selectedRow === row"
                (click)="onRowSelected(row)"
              ></mat-radio-button>
            </td>
          </ng-container>

          <!-- Actor name -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Actor name</th>
            <td mat-cell *matCellDef="let element">{{ element.name }}</td>
          </ng-container>

          <!-- Actor type -->
          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef>Actor type</th>
            <td mat-cell *matCellDef="let element">{{ element.type }}</td>
          </ng-container>

          <!-- Profile link -->
          <ng-container matColumnDef="profileLink">
            <th mat-header-cell *matHeaderCellDef>Profile link</th>
            <td mat-cell *matCellDef="let element">
              @if (element.profileLink) {
                <a [href]="element.profileLink" [matTooltip]="element.profileLink" target="_blank" rel="noopener">{{
                  element.profileLink
                }}</a>
              } @else {
                -
              }
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="foundActorsColumns"></tr>
          <tr
            class="table-row"
            mat-row
            *matRowDef="let row; columns: foundActorsColumns"
            (click)="onRowSelected(row)"
          ></tr>
        </table>

        <mat-paginator [length]="dataSource.data.length" [pageSize]="5"></mat-paginator>

        @if (!dataSource.data.length) {
          <p>No Actors found.</p>
        }
      </div>
    </div>

    @if (editMode === 'createAnActor') {
      <form [formGroup]="createActorForm">
        <mat-form-field appearance="outline" floatLabel="always" class="container-full-width">
          <mat-label>Actor name</mat-label>
          <input matInput formControlName="name" />
          @if (createActorForm.controls['name'].hasError('required')) {
            <mat-error> Actor name is <strong>required</strong> </mat-error>
          }
          @if (createActorForm.controls['name'].hasError('nameExists')) {
            <mat-error> An actor with this name already exists. Please choose a different name. </mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always" class="container-full-width">
          <mat-label>Actor type</mat-label>
          <mat-select formControlName="type">
            @for (option of actorTypeOptions; track option) {
              <mat-option [value]="option.value">
                {{ option.label }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always" class="container-full-width">
          <mat-label>Profile link</mat-label>
          <input matInput formControlName="profileLink" type="url" />
        </mat-form-field>
      </form>
    }

    <!-- Save and Cancel buttons -->
    <!-- This is projected by the ng-content of the app-base-modal -->
    <div panel-footer>
      <button
        [disabled]="isSavingData || isLoadingMotivationSuggestion"
        mat-flat-button
        class="button-link"
        (click)="onCancel()"
      >
        Cancel
      </button>
      <button
        [disabled]="
          isSavingData || isLoadingMotivationSuggestion || this.createActorForm.invalid || !this.createActorForm.dirty
        "
        mat-flat-button
        class="button-primary"
        (click)="onSaveAsync()"
      >
        Save
      </button>
    </div>
  </app-base-modal>

  <!-- spinner data -->
  @if (isLoadingSearchResults || isLoadingMotivationSuggestion) {
    <div class="spinner-wrapper">
      <mat-spinner class="spinner" [diameter]="32"></mat-spinner>
      <p>{{ isLoadingMotivationSuggestion ? 'Checking actor motivation...' : 'Searching actors...' }}</p>
    </div>
  }
</div>
